import { addItem, getItems, updateItem, deleteItem } from './db';

let ProductsTable = 'Products';

export async function saveProducts(data) {
    for await (const element of data) {
        await addItem(ProductsTable, element, '_id');
    }
}

export async function getProducts() {
    return await getItems(ProductsTable);
}